/**
 * User: CHT
 * Date: 2020/5/8
 * Time: 14:01
 */
import { uuid } from './index';
import { CONDITION_HEAD_NODE_HEIGHT, DRAG_NODE_HEIGHT, END_DISTANCE, NODE_DISTANCE_X, } from './const';
import * as d3 from 'd3';
export default class GraphLink {
    static distance = NODE_DISTANCE_X;
    static distance_output = END_DISTANCE;
    static distance_merge = 0;
    static distance_point_merge_vector = [0, 0];
    $options;
    key;
    graph;
    start;
    meta;
    startId;
    endId;
    id;
    constructor(options, graph) {
        const { meta = null, startId, endId, id } = options;
        this.$options = options;
        this.key = uuid('link');
        this.graph = graph;
        this.meta = meta;
        this.startId = startId;
        this.endId = endId;
        this.id = id;
    }
    // 创建路径
    createPath() {
        const link = this.$options;
        const pointMap = this.graph.nodeMap;
        const startNode = pointMap[link.startId];
        const endNode = pointMap[link.endId];
        const path = d3.path();
        const startX = startNode.coordinate[0] + startNode.width; // 开始节点x位置
        const startY = startNode.coordinate[1] + CONDITION_HEAD_NODE_HEIGHT / 2; // 开始节点y位置
        const outputDistance = this.meta?.activeId !== -1 ? GraphLink.distance_merge : GraphLink.distance_output; // 出口的间距 出口的间距是固定的
        const distance = endNode.coordinate[0] - startX; // 线左右之间的总距离
        const firstDistance = distance - outputDistance; // 首次拐点的距离
        const cpx1 = startX + firstDistance; // 第一个拐点控制点 x
        const cpy1 = startY; // 第一个拐点控制点 y
        const cpx2 = cpx1; // 第二个拐点控制点 x
        let cpy2 = endNode.coordinate[1] + CONDITION_HEAD_NODE_HEIGHT / 2; // 第二个拐点控制点 y
        if (link?.meta?.isDragElement) {
            cpy2 = endNode.coordinate[1] + DRAG_NODE_HEIGHT / 2; // 拖拽节点中间高度
        }
        const endX = endNode.coordinate[0]; // 结束位置x
        const endY = cpy2; // 结束位置y
        const startPoint = [startX, startY];
        path.moveTo(...startPoint); //起始点移动到指定的坐标
        path.lineTo(cpx1, cpy1); // 第一个拐点
        path.moveTo(cpx1, cpy1);
        path.lineTo(cpx2, cpy2); // 第二个拐点
        path.moveTo(cpx2, cpy2);
        path.lineTo(endX, endY); // 结束坐标
        path.closePath();
        return path;
    }
    createInsertPath() { }
    // 创建连线
    createLink({ g, style: { color } }, eventCallback) {
        const path = this.createPath();
        // 绘制连线点击热区
        g.append('path')
            .classed('link-path-hot', true)
            // .attr('data-id', this.meta?.activeId)
            .attr('d', path)
            .attr('visibility', 'hidden')
            .attr('pointer-events', 'stroke')
            .attr('stroke-width', 11)
            .attr('fill', 'none')
            .attr('stroke', 'white');
        // 绘制实际可见连线
        g.append('path')
            .classed('link-path', true)
            .attr('data-id', this.meta?.activeId)
            .attr('d', path)
            .attr('pointer-events', 'stroke')
            .attr('stroke-width', 1)
            .attr('fill', 'none')
            .attr('stroke', color);
        const selection = g.select('.link-path');
        selection.merge(g);
        this.createTerminalPoint({ g, color });
        g.on('click', eventCallback);
    }
    createArc() {
        const link = this.$options;
        const startPath = d3.path();
        const endPath = d3.path();
        const pointMap = this.graph.nodeMap;
        const startNode = pointMap[link.startId];
        const endNode = pointMap[link.endId];
        const startX = startNode.coordinate[0] + startNode.width + 3; // 开始节点x位置
        const startY = startNode.coordinate[1] + CONDITION_HEAD_NODE_HEIGHT / 2; // 开始节点y位置
        const endX = endNode.coordinate[0] - 3.5; // 结束位置x
        let endY = endNode.coordinate[1] + CONDITION_HEAD_NODE_HEIGHT / 2; // 结束位置 y
        if (link?.meta?.isDragElement) {
            endY = endNode.coordinate[1] + DRAG_NODE_HEIGHT / 2; // 拖拽节点中间高度
        }
        endPath.arc(endX, endY, 3, 0, Math.PI * 2, true);
        startPath.arc(startX, startY, 3, 0, Math.PI * 2, true);
        return {
            startPath,
            endPath,
        };
    }
    // 创建端点
    createTerminalPoint({ g, color }) {
        const { startPath, endPath } = this.createArc();
        if (this.meta?.activeId === -1) {
            g.append('path')
                .classed('link-end-point', true)
                .attr('d', endPath)
                .attr('fill', color)
                .attr('stroke', 'none');
        }
        if (this.isMergeNodeStart())
            return;
        g.append('path')
            .classed('link-start-point', true)
            .attr('data-id', this.meta?.activeId)
            .attr('d', startPath)
            .attr('fill', color)
            .attr('stroke', 'none');
    }
    // 是否以合并节点为开始节点
    isMergeNodeStart() {
        const startId = this.$options.startId;
        const pointMap = this.graph.nodeMap;
        const node = pointMap[startId];
        return !!node?.meta?.extParam?.isMergeNode;
    }
}
